import { tinLimit } from "@src/apps/constants/constant";
import { ROUTES_PATHS } from "@src/constants/routes";
import { config } from '@uhg-abyss/web/tools/config';

export interface Option {
    title: string;
    value: string;
}
export const TAB_KEYS = {
    HEALTH_SYSTEM: 'HEALTH_SYSTEM',
    TAX_ID: 'TAX_ID',
    CONTRACT_ID: 'CONTRACT_ID',
    GEO_SEGMENTATION: 'GEO_SEGMENTATION',
    SAVE_TAXID: 'SAVE_TAXID',
} as const;

const APP_CONSTANT = {
    SAVE_TAXID: 'SAVE_TAXID',
    TAB_KEYS,
    SEARCH_HEADING: {
        HEALTH_SYSTEM: 'Choose Provider(s)',
        TAX_ID: 'Choose Provider(s)',
        CONTRACT_ID: 'Choose Provider(s)',
        GEO_SEGMENTATION: 'Search by Geographic Segment',
        SAVE_TAXID: 'Choose Provider(s)'
    },
    PNB_SEARCH_HEADING: 'Provider Search',
    TAB_OPTION: [
        {
            key: TAB_KEYS.HEALTH_SYSTEM,
            tabTitle: 'Parent Entity',
            tabSubTitle: 'Search for Parent Entity Name, Genesis ID',
            placeholder: 'Enter Parent Entity Name or Genesis ID',
            label: 'Dynamic Search',
            description: 'Please type at least three (3) characters to start your search. Then, select a health system or Genesis ID from the list that appears.',
            noOptionsMessage: 'Please type at least 3 characters to start your search...',
            topSearchTitle: 'Frequently Viewed Parent Entities',
            adobeSearchLabel: 'search by health system name',
        },
        {
            key: TAB_KEYS.SAVE_TAXID,
            tabTitle: 'Saved Tax ID Lists',
            tabSubTitle: 'Select and view your saved custom Tax ID lists.',
            placeholder: 'Search Saved Tax ID Lists',
            label: 'Dynamic Search',
            description: 'Select and view your saved custom Tax ID lists.',
            noOptionsMessage: 'Please type at least 3 characters to start your search...',
            topSearchTitle: 'Select and view your saved custom Tax ID lists.',
            adobeSearchLabel: 'search by saved custom tax id',
            disabledInputSearch: true,
        },
        {
            key: TAB_KEYS.TAX_ID,
            tabTitle: 'Tax ID Name or Number Search',
            tabSubTitle: 'Select a Tax ID associated with a health system',
            placeholder: `Search Tax ID Number(s) or Name(s)`,
            label: 'Dynamic Search',
            description: 'Please type at least three (3) characters to start your search. Then, you may select facilities, physicians, or Tax IDs across multiple affiliations and save up to five (5) custom Tax ID lists.',
            noOptionsMessage: 'Please type at least 3 characters to start your search...',
            topSearchTitle: 'Frequently Viewed Facilities and Physicians',
            adobeSearchLabel: 'search by single tax id',
            link: 'Enter Multiple TINs'
        },
        {
            key: TAB_KEYS.CONTRACT_ID,
            tabTitle: 'Contract ID Search',
            tabSubTitle: 'Please enter at least 3 numbers to begin your search.',
            placeholder: `Enter Contract ID`,
            label: 'Dynamic Search',
            description: 'Please type at least three (3) characters to start your search. Then, you may select facilities, physicians, or Tax IDs across multiple affiliations and save up to five (5) custom Tax ID lists.',
            noOptionsMessage: 'Please type at least 3 characters to start your search...',
            topSearchTitle: 'Frequently Viewed Contracts',
            adobeSearchLabel: 'search by contract id search',
            link: 'Enter Multiple TINs'
        },
        {
            key: TAB_KEYS.GEO_SEGMENTATION,
            tabTitle: 'Geographic Search',
            tabSubTitle: 'Search by Region, State or Market',
            placeholder: 'Enter Region, State or Market',
            label: 'Dynamic Search',
            description: 'Please type at least three (3) characters to start your search.',
            noOptionsMessage: 'Please type at least 3 characters to start your search...',
            topSearchTitle: 'Frequently Viewed Geographic Segments',
            adobeSearchLabel: 'search by geographic segmentation',
        }
    ],
    TAB_OPTIONS_PSMS: [
        {
            key: TAB_KEYS.HEALTH_SYSTEM,
            tabTitle: 'Parent Entity',
            tabSubTitle: 'Search for Parent Entity Name',
            placeholder: 'Enter Parent Entity Name',
            label: 'Dynamic Search',
            description: 'Please type at least three (3) characters to start your search. Then, select a health system from the list that appears.',
            noOptionsMessage: 'Please type at least 3 characters to start your search...',
            topSearchTitle: 'Frequently Viewed Parent Entities',
            adobeSearchLabel: 'search by health system name',
        },
        {
            key: TAB_KEYS.TAX_ID,
            tabTitle: 'Tax ID Name or Number Search',
            tabSubTitle: 'Select a Tax ID associated with a health system',
            placeholder: `Search Tax ID Number(s) or Name(s)`,
            label: 'Dynamic Search',
            description: 'Please type at least three (3) characters to start your search. Then, you may select facilities, physicians, or Tax IDs across multiple affiliations and save up to five (5) custom Tax ID lists.',
            noOptionsMessage: 'Please type at least 3 characters to start your search...',
            topSearchTitle: 'Frequently Viewed Facilities and Physicians',
            adobeSearchLabel: 'search by single tax id',
            link: 'Enter Multiple TINs'
        },
        {
            key: TAB_KEYS.GEO_SEGMENTATION,
            tabTitle: 'Geographic Search',
            tabSubTitle: 'Search by Region, State or Market',
            placeholder: 'Enter Region, State or Market',
            label: 'Dynamic Search',
            description: 'Please type at least three (3) characters to start your search.',
            noOptionsMessage: 'Please type at least 3 characters to start your search...',
            topSearchTitle: 'Frequently Viewed Geographic Segments',
            adobeSearchLabel: 'search by geographic segmentation',
        },
    ],
    EXTRA_OPTION_TYPE: {
        firstOption: 'RESET_BTN',
        lastOption: 'VIEW_BTN',
        lastSecondOption: 'LAST_SECOND_OPTION',
    },
    GEO_SEGMENTATION_SEARCH: {
        RegionNames: 'REGION',
        MajorMarketNames: 'MARKET',
        States: 'STATE',
    },
    GEO_SEGMENTATION_SAVE: {
        REGION: 'Regions',
        MARKET: 'Markets',
        STATE: 'States',
    },
    GEO_SEGMENTATION_STORAGE: {
        REGION: 'GEO_SELECTED_REGION',
        MARKET: 'GEO_SELECTED_MARKET',
        STATE: 'GEO_SELECTED_STATES',
    },
    GEO_SETTLEMENT_SEGMENTATION_STORAGE: {
        REGION: 'SETTLEMENT_GEO_SELECTED_REGION',
        MARKET: 'SETTLEMENT_GEO_SELECTED_MARKET',
        STATE: 'SETTLEMENT_GEO_SELECTED_STATES',
    },
    GEO_VBC_SEGMENTATION_STORAGE: {
        REGION: 'VBC_GEO_SELECTED_REGION',
        MARKET: 'VBC_GEO_SELECTED_MARKET',
        STATE: 'VBC_GEO_SELECTED_STATES',
    },
    PI_GEO_SEGMENTATION_STORAGE: {
        REGION: 'PI_GEO_SELECTED_REGION',
        MARKET: 'PI_GEO_SELECTED_MARKET',
        STATE: 'PI_GEO_SELECTED_STATES',
    },
    GEO_PSMS_SEGMENTATION_STORAGE: {
        REGION: 'PSMS_GEO_SELECTED_REGION',
        MARKET: 'PSMS_GEO_SELECTED_MARKET',
        STATE: 'PSMS_GEO_SELECTED_STATES',
    },
    PAYLOAD_PROPS: {
        providerSearchType: 'hco',
        genesisProviderSearchType: 'genesisid',
        singleTaxIdSearchType: 'tin',
        multiTaxIdSearchType: 'multitin',
        taxNameSearchType: 'tinname',
        geoSegSearchType: 'geoSegmentation',
        searchPage: 1,
        searchLimit: 20,
        providerSaveSearchType: 'H',
        taxIdSaveSearchType: 'T',
        saveGroupName: '',
        saveGroupStatus: 'draft',
        saveGroupLastViewed: true,
        saveGroupSelectionType: 'TIN',
    },
    MESSAGES: {
        altLoaderMsg: 'Loading ...',
        maxTinsMsg: `Maximum ${tinLimit} TINs selected.`,
        noAdditionalMsg: 'No additional result found for your input search',
    },
    OVERVIEW_PAGE_URL: ROUTES_PATHS.Overview.OverviewAdvocate,
    ERRORS: {
        tinInvalid: 'No results were found. The TIN(s) may be inactive, non-participating, or lacking claims or prior authorization data. Please try re-entering the TIN(s), ensuring that each TIN contains a total of 9 digits (include leading 0s) and that a comma separates each TIN listed',
        contractIdInvalid: 'No results were found. The Contract ID may be inactive, non-participating, or lacking claims or prior authorization data. Please try re-entering the Contract ID, ensuring it contains exactly 4-8 digits (include leading 0s)',
        noMarketFound: 'No results populate'
    },
    STATUS_CODE: {
        OK: 200,
        CREATED: 201,
        NO_CONTENT: 204,
        BAD_REQUEST: 400,
        UNAUTHORIZED: 401,
        FORBIDDEN: 403,
        NOT_FOUND: 404,
        INTERNAL_SERVER_ERROR: 500,
        SERVICE_UNAVAILABLE: 503
    },
    INITIAL_STATE: {
        affTaxId: [{ Tin: 'All', Tinname: 'All' }],
        vbcTaxId: [{ Tin: 'All', Tinname: 'All' }],
        exemptionTaxId: [{ Tin: 'All', Tinname: 'All' }],
        reconGlobal: {},
        Tins: [],
        selectedCorporateTin: { name: '', value: '', disable: false },
        legendGlobal: {},
        extendedCorporateTinSelected: {
            TINNAME: 'All',
            Tin: 'All Selected TINs',
            Tinname: 'All',
            isEnabled: false,
            isSelected: false
        },
        journeyExtendedTinSelected: {
            taxId: [],
            affTaxId: [],
            priorAuthTaxId: [],
            smartEditTaxId: [],
            vbcTaxId: [],
            exemptionTaxId: []
        },
        journeyExtendedTinFilterSelected: {
            taxId: [{ TINNAME: 'All', Tin: 'All', Tinname: 'All', isEnabled: false, isSelected: false }],
            affTaxId: [{ TINNAME: 'All', Tin: 'All', Tinname: 'All', isEnabled: false, isSelected: false }],
            priorAuthTaxId: [{ TINNAME: 'All', Tin: 'All', Tinname: 'All', isEnabled: false, isSelected: false }],
            smartEditTaxId: [{ TINNAME: 'All', Tin: 'All', Tinname: 'All', isEnabled: false, isSelected: false }],
            vbcTaxId: [{ TINNAME: 'All', Tin: 'All', Tinname: 'All', isEnabled: false, isSelected: false }],
            exemptionTaxId: [{ TINNAME: 'All', Tin: 'All', Tinname: 'All', isEnabled: false, isSelected: false }]
        },
        hcoExtendedCorporateTinSelected: [],
        paymentClaimYeild: 'All',
        currentPage: 'overviewPage',
        currentUrl: ROUTES_PATHS.Overview.OverviewAdvocate,
        currentComponent: '',
        timePeriod: 'Last12Months',
        timePeriodVBC: new Date().getMonth() === 0 ? (new Date().getFullYear() - 1).toString() : new Date().getFullYear().toString(),
        taxId: [{ Tin: 'All', Tinname: 'All' }],
        taxIdSmartEdit: [{ Tin: 'All', Tinname: 'All' }],
        lineOfBusiness: 'All',
        adjudicationType: 'All',
        region: 'NATIONAL',
        states: [],
        market: '',
        mapping: 'PROVIDER',
        edcLineOfBusiness: { order: '1', value: 'Commercial', name: 'COMMERCIAL' },
        dplineOfBusiness: 'All',
        productType: [{ ClaimProducts: ['All'], ClaimSystem: 'All', Lob: ['All'], ProductName: 'All' }],
        reconsiderationValues: 'All',
        adjustmentValues: 'All',
        commercial: 'All',
        channel: 'All',
        serviceSetting: 'All',
        providerSetting: 'Requesting Provider',
        serviceCategory: 'All',
        priorAuthType: 'All',
        trendMetric: 'Reimbursements',
        trendDate: new Date(),
        claimsFilter: 'All',
        ClaimProducts: [],
        appealsFilter: 'Received Date',
        viewClaimsByFilter: 'DOS',
        platformType: [{ name: 'All', value: 'All', check: true }],
        topFilterTimePeriod: {
            FilterText: 'All',
            StartDate: 'All',
            EndDate: 'All',
            Default: 'All'
        },
        topFilterTin: { Tin: 'All', TinName: 'All' },
        topFilterNpi: { Npi: 'All', NpiName: 'All' },
        topFilterSpeciality: { Speciality: 'All' },
        topFilterLob: { Lob: 'All' },
        priorAuthFilters: {
            timePeriod: 'Last12Months',
            timePeriodText: '',
            taxId: [{ Tin: 'All', Tinname: 'All' }],
            lineOfBusiness: 'All',
            providerSetting: 'Requesting Provider',
            channel: 'All',
            serviceSetting: 'All',
            serviceCategory: 'All',
            npi: { Value: 'All', Name: 'All' },
            specialty: { Value: 'All', Name: 'All' }
        },
        gapsInCareFilters: {
            TimePeriod: { title: 'All', value: 'All' },
            Lob: { pages: ['GAPS_IN_CARE'], title: 'All', value: 'All' },
            Tin: { Tin: 'All', Tinname: 'All' },
            Npi: { Npi: 'All', NpiName: 'All' }
        },
        PACaseSubmissionFilters: {
            TimePeriod: { title: 'All', value: 'All' },
            Lob: { pages: ['PA_CASE_SUBMISSION'], title: 'All', value: 'All' },
            Tin: { Tin: 'All', Tinname: 'All' },
            Npi: { Npi: 'All', NpiName: 'All' }
        },
        glossaryOpen: false,
        tileIds: [],
        selectedPoca: {
            timePeriod: { POCAViewKeys: ["EMR", "ELINK", "SYSTEM_PAAN"], title: '', value: '' },
            taxId: { Tin: 'All', Tinname: 'All' },
            lob: 'All',
            channel: 'EMR',
            npi: { Npi: 'All', NpiName: 'All' }
        },
        multiSelectData: {
            tabIndex: 0,
            groupName: ''
        },
        affordabilityPrograms: {},
        ADMFilters: { Lob: {}, State: {} },
        LOCFilters: { Lob: {}, View: {} },
        startDate: '',
        endDate: '',
        selectedState: { name: '', value: '' },
        tinsInfo: [],
        priorAuth: {
            TaxId: { title: 'All', value: 'All' },
            Npi: { title: 'All', value: '' },
            Specialty: { title: 'All', value: '' },
            Timeperiod: 'Last12Months',
            TimeperiodText: ''
        }
    },
    EXCLUDED_KEYS: ['Tab', 'Enter', 'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight',
        'Backspace', 'Delete', 'Escape', 'Shift', 'Control', 'Alt',
        'CapsLock', 'Home', 'End', 'PageUp', 'PageDown', 'Insert', 'Meta'],
    TEMPLATE_TYPE: {
        templateType: {
            title: 'Template Type',
            type: 'dropDown',
            selectedValue: {
                title: '',
                value: 'Template Type',
            },
            width: '375px',
            filterDisplayKey: 'value',
            filterValueKey: 'value',
            options: [{ title: 'type1', value: 'Ancillary' }, { title: 'type2', value: 'Facility' }, { title: 'type3', value: 'Tier 1 & 2 Independent Physician Group' }],
            filterKey: 'title',
            key: 'value',
            activeFilter: true,
            dropDowndisabled: false,
            stylingAdd: true
        }
    },
    // TAX_ID:{
    //     taxId: {
    //         selectedValue: { title: 'All Tax IDs', value: 'All Tax IDs' },
    //         type: 'DynamicSearch',
    //         width: '200px',
    //         filterOptionsSize: 'small',
    //         options: [] as Option[],
    //         activeFilter: true,
    //         disableSC: false,
    //         resetFilter: true,
    //         showFilter: true,
    //         filterDisplayKey: 'title',
    //         filterOptionType: 2,
    //         filterValueKey: 'value',
    //         sliceArray: true,
    //         filterKey: 'value',
    //         filterLabel: 'All Tax IDs', //for filter chips needs handle
    //         dropdownNote: 'TaxID',
    //         searchType: 2,
    //         hco: '',
    //         stylingAdd: true
    //       }
    // }
};
export default APP_CONSTANT;

export const getInitializeState = () => {
    const initialState: any = APP_CONSTANT.INITIAL_STATE;
    const serializedState = sessionStorage.getItem('state');
    if (serializedState) {
        const parsedState = serializedState ? JSON.parse(serializedState) : null;
        if (parsedState) {
            initialState.currentComponent = parsedState.currentComponent;
            if (parsedState.gapsInCareFilters) {
                initialState.gapsInCareFilters.TimePeriod = parsedState.gapsInCareFilters.TimePeriod;
            }
            if (parsedState.PACaseSubmissionFilters) {
                initialState.PACaseSubmissionFilters.TimePeriod = parsedState.PACaseSubmissionFilters.TimePeriod;
            }
            if (parsedState.selectedPoca) {
                initialState.selectedPoca.timePeriod = parsedState.selectedPoca.timePeriod;
            }
        }
    }
    return initialState;
}
export const NAV_PATH = {
    providerBriefing: ROUTES_PATHS.Providers.Briefing,
    healthSystem: ROUTES_PATHS.Overview.HealthSystem,
}

export const isFlagEnabled = (value: unknown): boolean => {
    if (typeof value === 'boolean') return value;
    if (typeof value === 'string') {
        return value.toLowerCase() === 'true';
    }
    return false;
};


export const RELEASE_FEATURE_FLAGS = {
    augustReleaseEnable: 'AUGUST_RELEASE_ENABLE',
} as const;

export const isAugustReleaseEnabled = () => Boolean(config(RELEASE_FEATURE_FLAGS.augustReleaseEnable));